import type { CheckProps } from '@/components/header/components/check/check.types';
import { CircleCheck } from 'lucide-react';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/header/components/check/check-v1.css';
import '@/components/header/components/check/check-v2.css';

export default function Check(props: CheckProps) {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);

  return (
    <div data-css-version={cssVersion} className='header-check'>
      <CircleCheck className='header-check__icon' />
      <span className='header-check__text' dangerouslySetInnerHTML={{ __html: props.text }} />
    </div>
  );
}
